import { createSlice } from '@reduxjs/toolkit';
import { useHistory } from 'react-router-dom';

// Slice
const initialDashboardState = {
    employeeActionItems: [],
};

const slice = createSlice({
    name: 'dashboard',
    initialState: initialDashboardState,
    reducers: {
        saveEmployeeActionData: (state, action) => {
            state.employeeActionItems = action.payload;
        }
    },
});

export default slice.reducer;

// Actions
const { saveEmployeeActionData } = slice.actions;

export const saveEmployeeActionItems = (actionItems) => async dispatch => {
    try {
        dispatch(saveEmployeeActionData(actionItems));
    } catch (e) {
        return console.error(e.message);
    }
}
